import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";

const EditHighlight = ({ fetchAllMagazine }) => {
    const { id } = useParams();
    const history = useNavigate();
    const [showPreview, setShowPreview] = useState(false);
    const [imagePreview, setImagePreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [articleOption, setArticleOption] = useState([]);
    const [highlight, setHighlight] = useState([]);
    const formRef = useRef(null);
    const [TypeOption, setTypeOption] = useState([
        { value: 1, label: "Today highlight" },
        { value: 2, label: "Hot & Trending" },
    ]);

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    useEffect(() => {
        getDropDownArticles();
        fetchHighlight();
    }, []);

    const getDropDownArticles = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getDropDownArticles",
        });

        const output = response.data;

        if (output.length > 0) {
            setArticleOption(
                output.map((option) => ({
                    value: option.pk_ac_key,
                    label: option.ac_name,
                }))
            );
        }
    };

    const fetchHighlight = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                pk_hl_key: id,
                mode: "getHiglightList",
            });
            const result = response.data;
            setHighlight(result);
        } catch (error) {
            toast.error("Error fetching magazine details.", { autoClose: 3000 });
        }
    };

    const initialValues = {
        pk_hl_key: highlight && highlight.pk_hl_key ? highlight.pk_hl_key : "",
        highlight_type: highlight && highlight.highlight_type ? highlight.highlight_type : "",
        fk_ac_key: highlight && highlight.fk_ac_key ? highlight.fk_ac_key : "",
        highlight_order: highlight && highlight.highlight_order ? highlight.highlight_order : "",
        updated_by: sessionStorage.getItem("pk_user_key"),
    };

    const basicSchema = Yup.object().shape({
        highlight_type: Yup.string().required("Please select type."),
        fk_ac_key: Yup.string()
            .required("Article is required.")
            .test("unique-link", "Article already existing in the highlight list", async function (value) {
                if (!value) return true;
                const isArticleUnique = await checkHighlightList(value);
                return isArticleUnique;
            }),
        highlight_order: Yup.number()
            .typeError("Order must be a number.")
            .required("Order is required.")
            .positive("Order must be a positive number.")
            .integer("Order must be an integer.")
            .test("unique-link", "This order already exists for this type", async function (value) {
                const { highlight_type } = this.parent;
                if (!value || !highlight_type) return true;
                const isOrderUnique = await checkOrder(value, highlight_type);
                return isOrderUnique;
            }),
    });

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "editHighlightList",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                toast.success("Updated successfully!");
                setTimeout(() => history("/admin/highlight-settings"), 3000);
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    async function checkHighlightList(fk_ac_key) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkHighlightList",
            fk_ac_key: fk_ac_key,
            pk_hl_key: id,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const checkOrder = async (highlight_order, highlight_type) => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkOrder",
            pk_hl_key: id,
            highlight_order: highlight_order,
            highlight_type: highlight_type,
        });

        const output = response.data;
        return output == 1 ? false : true;
    };

    const { values, handleChange, handleBlur, touched, errors, handleSubmit, setFieldValue, setTouched, resetForm, setValues } = formik;

    return (
        <div className="container mt-4 bg-white p-4 mb-3">
            <ToastContainer position="top-center" />
            <Form className="mb-3" onSubmit={handleSubmit}>
                <Form.Group className="d-flex justify-content-between mb-3">
                    <h4 className="mb-2">Edit Highlight List</h4>
                    <div>
                        <Button variant="dark" type="submit" ref={formRef} disabled={isSubmitting}>
                            Edit
                        </Button>
                    </div>
                </Form.Group>
                <Form.Group className="w-100 mb-3">
                    <Form.Label>
                        Highlight Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                        options={TypeOption}
                        id="highlight_type"
                        name="highlight_type"
                        value={TypeOption.find(
                            (option) => option.value && values.highlight_type && option.value.toString() === values.highlight_type.toString()
                        )}
                        onChange={(selectedOption) => {
                            const event = {
                                target: {
                                    name: "highlight_type",
                                    value: selectedOption["value"],
                                },
                            };
                            handleChange(event);
                        }}
                        onBlur={(event) => {
                            handleBlur(event);
                            setTouched({ ...touched, highlight_type: true });
                        }}
                    />

                    {errors.highlight_type && touched.highlight_type && <p className="text-danger">{errors.highlight_type}</p>}
                </Form.Group>
                <Form.Group className="w-100 mb-3">
                    <Form.Label>
                        Article <span className="text-danger">*</span>
                    </Form.Label>
                    <Select
                        options={articleOption}
                        id="fk_ac_key"
                        name="fk_ac_key"
                        value={articleOption.find((option) => option.value && values.fk_ac_key && option.value.toString() === values.fk_ac_key.toString())}
                        onChange={(selectedOption) => {
                            const event = {
                                target: {
                                    name: "fk_ac_key",
                                    value: selectedOption["value"],
                                },
                            };
                            handleChange(event);
                        }}
                        onBlur={(event) => {
                            handleBlur(event);
                            setTouched({ ...touched, fk_ac_key: true });
                        }}
                    />

                    {errors.fk_ac_key && touched.fk_ac_key && <p className="text-danger">{errors.fk_ac_key}</p>}
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>
                        Order <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        name="highlight_order"
                        value={values.highlight_order}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Enter highlight order"
                    />
                    {errors.highlight_order && touched.highlight_order && <p className="text-danger">{errors.highlight_order}</p>}
                </Form.Group>
            </Form>
        </div>
    );
};

export default EditHighlight;
